<template>
<!--  <div id="app">-->
    <!--    <img src="./assets/logo.png">-->
    <router-view/>
    <!--    <keep-alive>-->
    <!--      <router-view v-if="$route.meta.keepAlive"></router-view>-->
    <!--    </keep-alive>-->
    <!--    <router-view v-if="!$route.meta.keepAlive"></router-view>-->
    <!--  </div>-->
</template>

<script>

export default {
  name: 'App',
  mounted() {
    // RDevice.getInfo();
  }
}
</script>


<style lang="css">
@import "base/css/css_reset.css";
</style>



// WEBPACK FOOTER //
// src/App.vue